import { URL } from '../../config'
import { getRequest,postRequest } from '../../utils/httpRequest'
import { 
	FETCH_SEASON_RANKINGS,
  FETCH_AVAILABLE_RANKINGS,
  FETCH_LAST_RANKING_RUN,
	FETCH_SEASON_WEEKS,
    RUN_SEASON_RANKINGS,
    PUBLISH_RANKINGS
} from '.'

const seasonURL = URL.season

export function fetchSeasonRankings(seasonId, weekNo, gender) {
    const url = `${seasonURL}/${seasonId}/rankings/${weekNo}/${gender}`
    const request = getRequest(url)
    return {
			type: FETCH_SEASON_RANKINGS,
			payload: request
    }
}
export function fetchAvailableRankings(){
    const url = `${seasonURL}/availablerankings`
    const request = getRequest(url)
    return {
			type: FETCH_AVAILABLE_RANKINGS,
			payload: request
    }
}

export function fetchLastRankingRun() {
  const url = `${seasonURL}/lastrankingrun`
  const request = getRequest(url)
  return {
    type: FETCH_LAST_RANKING_RUN,
    payload: request
  }
}

export function fetchSeasonWeeks(seasonId){
    const url = `${seasonURL}/${seasonId}/weeks`
    const request = getRequest(url)
    return {
			type: FETCH_SEASON_WEEKS,
			payload: request
    }
}

export function runRankings(seasonYear, token)
{
    const url = `${seasonURL}/runrankings/${seasonYear}`
    const request = postRequest(url, {}, token)
    return {
			type: RUN_SEASON_RANKINGS,
			payload: request
    }
}

export function publishRankings(seasonId) {
    
  const url = `${seasonURL}/${seasonId}/publishRankings`
    const request = postRequest(url)
    return {
            type: PUBLISH_RANKINGS,
            payload: request
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/action_season.js